var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.59,
    height: 20.5,
    viewBox: "0 0 18.59 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #7d7d7d;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #7d7d7d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10515",
    "data-name": "Group 10515",
    transform: "translate(-189.5 -777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9609",
    "data-name": "Group 9609",
    transform: "translate(190 777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9607",
    "data-name": "Group 9607",
    transform: "translate(5.542 8.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-1",
    d: "M-4821.181-21686.6l-.51,7.887",
    transform: "translate(4827.475 21686.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-1",
    d: "M-4823.515-21686.6v7.891",
    transform: "translate(4826.647 21686.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-1",
    d: "M-4825.692-21686.6l.5,7.9",
    transform: "translate(4825.692 21686.602)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7068",
    "data-name": "Path 7068",
    className: "cls-2",
    d: "M13.494,1l-1.2,14.458a1.2,1.2,0,0,1-1.2,1.2H2.41a1.2,1.2,0,0,1-1.2-1.2L0,1",
    transform: "translate(2.048 3.337)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9608",
    "data-name": "Group 9608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-1",
    d: "M741,313.959h5.783",
    transform: "translate(-729.197 -312.152)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1800",
    "data-name": "Ellipse 1800",
    className: "cls-3",
    cx: 1.785,
    cy: 1.785,
    r: 1.785,
    transform: "translate(7.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7069",
    "data-name": "Path 7069",
    className: "cls-1",
    d: "M741,313.959h5.783",
    transform: "translate(-741.005 -312.152)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1500f66be864a55d3b02a5c5ca2f7897.svg";
export { ForwardRef as ReactComponent };